module.exports = __webpack_public_path__ + "fonts/dosis-v12-latin-ext_latin-regular.ttf";